export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_4.1-f0698c4a0911c338f8b036cfb18266b2.svg";